import axios from "axios";

const axiosInstance = axios.create();

axiosInstance.defaults.baseURL =
  process.env.API_URL || "https://southgloucestershire.secure-messaging.co.uk";

axiosInstance.defaults.headers.post["Content-Type"] = "application/json";

axiosInstance.interceptors.request.use(function (config) {
  const token = window.localStorage.getItem("token");

  config.headers.authorization = token ? token : "";

  return config;
});

export default axiosInstance;
